import { z } from "zod";
import { MustMatchAnyMatchNoneSchema } from "../common/common-filter-definitions-schema";

// Top-level keys
const TopLevelKeys = ["B2", "B8", "C1", "C2", "C2A", "C3", "C4", "E", "F.1", "F.2", "sui-generis"] as const;

// E items
const EKeys = ["E(a)", "E(b)", "E(c)", "E(c)(i)", "E(d)", "E(e)", "E(f)", "E(g)(i)"] as const;

// F.1 items
const F1Keys = ["F.1(a)", "F.1(b)", "F.1(c)", "F.1(d)", "F.1(f)", "F.1(g)"] as const;

// F.2 items
const F2Keys = ["F.2(b)", "F.2(c)", "F.2(d)"] as const;

// sui-generis items
const SuiGenerisKeys = [
  "i-Agricultural",
  "ii-Agricultural",
  "iii-Amusements",
  "iv-Bingo-Hall",
  "v-Car",
  "vi-Farm",
  "vii-Garage",
  "ix-Grazing",
  "x-Holiday",
  "xi-Licensed",
  "xii-Lock",
  "xiii-Permanent",
  "xiv-Petrol",
  "xv-car-parking",
  "xvi-Public",
  "xvii-Recreational",
] as const;

// Nested schemas for each key with items
const EItemSchema = z.object({
  key: z.enum(EKeys),
  checked: z.boolean(),
});

const F1ItemSchema = z.object({
  key: z.enum(F1Keys),
  checked: z.boolean(),
});

const F2ItemSchema = z.object({
  key: z.enum(F2Keys),
  checked: z.boolean(),
});

const SuiGenerisItemSchema = z.object({
  key: z.enum(SuiGenerisKeys),
  checked: z.boolean(),
});

// Main value schema
const ValueSchema = z.discriminatedUnion("key", [
  z.object({
    key: z.enum(TopLevelKeys.filter((k) => !["E", "F.1", "F.2", "sui-generis"].includes(k) as any)),
    checked: z.boolean(),
  }),
  z.object({ key: z.literal("E"), checked: z.boolean(), items: z.array(EItemSchema) }),
  z.object({ key: z.literal("F.1"), checked: z.boolean(), items: z.array(F1ItemSchema) }),
  z.object({ key: z.literal("F.2"), checked: z.boolean(), items: z.array(F2ItemSchema) }),
  z.object({ key: z.literal("sui-generis"), checked: z.boolean(), items: z.array(SuiGenerisItemSchema) }),
]);

export const UseClassFilterSchema = z
  .object({
    id: z.literal("use-class-nested-id"),
    values: z.array(ValueSchema),
    must: MustMatchAnyMatchNoneSchema,
    type: z.literal("nested-checkbox"),
  })
  .meta({
    description: `Filter parcels based on their use class designations.
      Use classes categorize land and buildings based on their current or intended use. 
      It represents the current restrictions for how a property can be used under local planning regulations.`,
  });
